import { render } from "./LoginConfirm.vue?vue&type=template&id=4fd58bdd&scoped=true&ts=true"
import script from "./LoginConfirm.vue?vue&type=script&lang=ts"
export * from "./LoginConfirm.vue?vue&type=script&lang=ts"

import "./LoginConfirm.vue?vue&type=style&index=0&id=4fd58bdd&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd58bdd"]])

export default __exports__